import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Label } from "@/components/ui/label";
import type { EditClientForm } from "@/lib/core/crm/types/contacts";

interface ClientNotesSectionProps {
  editForm: UseFormReturn<EditClientForm>;
  isOpen?: boolean;
  onToggle?: () => void;
  headerless?: boolean;
}

const Fields: React.FC<{ editForm: UseFormReturn<EditClientForm> }> = ({ editForm }) => (
  <>
    <Label htmlFor="edit-notes">Notes</Label>
    <textarea
      id="edit-notes"
      {...editForm.register("notes")}
      rows={3}
      className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      placeholder="Additional notes about the client..."
    />
  </>
);

export const ClientNotesSection: React.FC<ClientNotesSectionProps> = ({
  editForm,
  isOpen,
  onToggle,
  headerless,
}) => {
  if (headerless) {
    return (
      <div className="space-y-2">
        <Fields editForm={editForm} />
      </div>
    );
  }
  return (
    <div className="border rounded-lg">
      <button
        type="button"
        className="w-full flex justify-between items-center px-4 py-3 bg-card-50 hover:bg-card-100 font-semibold text-left"
        onClick={onToggle}
      >
        Notes
        <span>{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen && (
        <div className="p-4 space-y-2">
          <Fields editForm={editForm} />
        </div>
      )}
    </div>
  );
};
